module.exports = "https://cdn2-fs.clearscore.com/flux/images/6c28cefc6623ff6c748a2b1ad72c0d3a.jpg";